import { createContext } from 'react';

/**
 * Context holding the global notification stack state.
 *
 * Value shape (set by `NotificationsProvider`):
 * {
 *   pushNotif: (payload: NotificationPayload) => void,
 *   stack: Notification[],
 *   removeNotification: (notificationId: number) => void,
 * }
 *
 * `undefined` until a `NotificationsProvider` is mounted — `useNotifier`
 * throws when the context is missing.
 */
export const notificationsContext = createContext(undefined);

export const NotificationsContextProvider = notificationsContext.Provider;